<ng-container *ngIf="!loading">
  <app-card className="card--report">
    <app-smart-reporting-map-page
      [project]="project"
    ></app-smart-reporting-map-page>
  </app-card>

  <div class="conversations" *ngIf="notices.length">
    <app-card
      [className]="'card--conversation ion-activatable'"
      role="link"
      tabindex="0"
      (click)="openNotice(notice)"
      *ngFor="let notice of notices; let index = index"
    >
      <div class="card--conversation__meta">
        <span>#{{ index + 1 }}: {{ notice.theme.title }}</span>
        <span
          *ngIf="!DateHelper.isToday(notice.lastInteractionDate)"
          class="date"
          >{{ notice.lastInteractionDate | date : 'd-M-Y' }}</span
        >
        <span
          *ngIf="DateHelper.isToday(notice.lastInteractionDate)"
          class="date"
          >{{ notice.lastInteractionDate | date : 'shortTime' }}</span
        >
      </div>
      <div class="card--conversation__text">
        <div
          [innerHTML]="
            notice.responses?.length > 0
              ? notice.responses[notice.responses.length - 1].message
              : (notice.attachmentThumbnails ? '📷 ' : '') + notice.description
          "
        ></div>
        <span
          aria-hidden="true"
          [inlineSVG]="'/assets/icons/card/chevron-right.svg'"
        ></span>
        <ion-ripple-effect></ion-ripple-effect>
      </div>
    </app-card>
  </div>
</ng-container>
<app-loader [loading]="loading" [withPadding]="true"></app-loader>
